<template>
    <MultiStepView :isEdit="false" />
  </template>
  
  <script>
  import MultiStepView from './GroupedReport/MultiStepView.vue';
  
  export default {
    components: { MultiStepView },
  };
  </script>
  